module.exports = __webpack_public_path__ + "media/images/icon_nav_category_black-d3679a7c55a69fb45e00244a97f6a6db.svg";